import { render, staticRenderFns } from "./sos_detail.vue?vue&type=template&id=35873ba6&"
import script from "./sos_detail.vue?vue&type=script&lang=js&"
export * from "./sos_detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports